export const handleInputChange = ({ event, setData }: InputChangeProps) => {
	event?.preventDefault();
	setData(event?.target?.value);
};

export const handleVariantChange = ({
	variant,
	setSelectedVariant,
	setIsOpen,
}: VariantChangeProps) => {
	setSelectedVariant(variant);
	setIsOpen(false);
};
